export function formatUnitAsSnakeCase(unitString: string): string {
  return unitString?.replaceAll('/', '_');
}
